import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import Home from '@/views/Home.vue'
import AbountUs from '@/views/AbountUs.vue'
import Financing from '@/views/Financing.vue'
import ImmobileDetail from '@/views/ImmobileDetail.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'root',
    component: Home,
    meta: {
      title : 'ilios sistemas-Intranet'},
  },

  // SOMENTE 1 ROTA (SEM O BREADCRUMB)
  // {
  //   path: '/inicio',
  //   component: {
  //     render (c) {
  //       return c('router-view')
  //     }
  //   },
  //   meta: {
  //     breadCrumb : 'Inicio',
  //     title : 'IliosLar-Inicio',      
  //     requiresAuth : true },
  //   children: [
  //     {
  //       path: '',
  //       component: Home
  //     },
  //   ]
  // },

  // ROTA PAI COM ROTAS FILHA (COM BREADCRUMB)
  {
    path: '/inicio',
    component: {
      render (c) {
        return c('router-view')
      }
    },
    meta: { 
      breadCrumb: 'Início',
      title : 'IliosLar-Inicio'
    },
    children: [
      {
        path: '',
        component: Home
      },
    ]
  },

  {
    path: '/quem_somos',
    component: {
      render (c) {
        return c('router-view')
      }
    },
    meta: {
      breadCrumb : 'Quem somos',
      title : 'IliosLar-Quem somos'},
    children: [
      {
        path: '',
        component: AbountUs
      },
    ]
  },

  {
    path: '/financiamento',
    component: {
      render (c) {
        return c('router-view')
      }
    },
    meta: {
      breadCrumb : 'Financiamento',
      title : 'IliosLar-Financiamento'},
    children: [
      {
        path: '',
        component: Financing
      },
    ]
  },

  {
    path: '/informacoes_imovel',
    component: {
      render (c) {
        return c('router-view')
      }
    },
    meta: {
      breadCrumb : 'Informações do Imóvel',
      title : 'IliosLar-Informações do Imóvel'},
    children: [
      {
        path: '',
        component: ImmobileDetail
      },
    ]
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

//  router.beforeEach(async (to, from, next) =>  {
//   if (to.matched.some(route => route.meta.requiresAuth)) {
//     next();
//   }else {
//     console.log("Executing the default Next()");
//     next();
//   }

//   // // This goes through the matched routes from last to first, finding the closest route with a title.
//   // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
//   const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

//   // Find the nearest route element with meta tags.
//   const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
//   const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

//   // If a route with a title was found, set the document (page) title to that value.
//   if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

//   // Remove any stale meta tags from the document using the key attribute we set below.
//   Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

//   // Skip rendering meta tags if there are none.
//   // if(!nearestWithMeta) return next();

//   // Turn the meta tag definitions into actual elements in the head.
//   // nearestWithMeta.meta.metaTags.map(tagDef => {
//   //   const tag = document.createElement('meta');

//   //   Object.keys(tagDef).forEach(key => {
//   //     tag.setAttribute(key, tagDef[key]);
//   //   });

//   //   // We use this to track which meta tags we create, so we don't interfere with other ones.
//   //   tag.setAttribute('data-vue-router-controlled', '');

//   //   return tag;
//   // })
//   // // Add the meta tags to the document head.
//   // .forEach(tag => document.head.appendChild(tag));

// });
export default router;
